// extracted by mini-css-extract-plugin
export default {"ConteneurInfo":"Ajouter_ConteneurInfo__e5gQq","Formulaire":"Ajouter_Formulaire__3yfGK","btsSty":"Ajouter_btsSty__nnd5V","fore":"Ajouter_fore__cpHZS"};